import 'gsap/TweenLite';
import 'gsap/TweenMax';

const Search = class Search{

    constructor(config) {
        this.searchTrigger = config.searchTrigger;
        this.header = config.header;
        this.main = config.main;
        this.footer = config.footer;
        this.searchClose = config.searchClose;
        this.searchBox = config.searchBox;

    }

    init(){
        let searchTrigger = this.searchTrigger,
            header = this.header,
            main = this.main,
            footer = this.footer,
            searchClose = this.searchClose,
            searchBox = this.searchBox,
            isActive = false,
            translateY,
            translateYnegative;

            if (window.innerWidth <= 720) {
                translateY = 99
                translateYnegative = -99
            } else {
                translateY = 125
                translateYnegative = -125
            }

        searchTrigger.on("click", function(e) {
            if (isActive === false){
                e.preventDefault();

                let searchCta = $(this),
                    dataTarget = searchCta.attr("data-target"),
                    pageLoadTl = new TimelineMax();

                    setTimeout(()=> {
                        $(dataTarget).find('input[type="search"]').focus();
                    }, 300);

                    pageLoadTl.fromTo(dataTarget,0.5,{y: translateYnegative},
                        {
                            y: "0",
                            delay: 0,
                            force3D: "auto",
                            ease: Expo.easeOut
                        },"start").fromTo([header, main, footer],0.5,{y: "0"},
                        {
                            y: translateY,
                            delay: 0,
                            force3D: "auto",
                            ease: Expo.easeOut
                        },"start");

                    isActive = true;
            }else{
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        });

        searchClose.on("click", function(e) {
            e.preventDefault();

            let pageLoadTl = new TimelineMax();

            pageLoadTl.fromTo([header, main],0.5,{y: translateY},
                {
                    y: "0",
                    delay: 0,
                    force3D: "auto",
                    ease: Expo.easeOut
                },"start").fromTo(searchBox,0.5,{y: "0"},
                {
                    y: translateYnegative,
                    delay: 0.15,
                    force3D: "auto",
                    ease: Expo.easeOut
                },"start");

            isActive = false;
        });
    }

};

export {Search};


// WEBPACK FOOTER //
// ./static/js/components/SearchBox.js